



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ReadMore extends Vue {
	@Prop({ default: 0, type: Number }) minHeight!: number;
	@Prop({ default: 0, type: Number }) minItems!: number;

	/*
        Animation time in MS
    */
	@Prop({ default: 200, type: Number }) animationTime!: number;

	/*
        Percentage of height in px to alter the speed of animation
     */
	@Prop({ default: 0.2, type: Number }) animationTimeMod!: number;
	@Prop({ default: '', type: String }) buttonClass!: string;
	@Prop({ default: 'div', type: String }) tag!: string;
	@Prop({ default: false, type: Boolean }) expanded!: boolean;
	@Prop({ default: false, type: Boolean }) withFade!: boolean;

	isContentOverflowing: boolean = false;
	showFullContent: boolean = this.expanded;
	animationDuration: number = this.animationTime;

	public $refs!: {
		body: HTMLDivElement;
	};

	mounted() {
	    setTimeout(() => {
	        this.determineMode();
	        this.calculateAnimDuration();
	    }, 0);

	    const setAutoHeight = () => {
	        if (this.showFullContent) {
	            this.$refs.body.style.height = 'auto';
	        }
	    };

	    this.$refs.body.addEventListener('transitionend', () => setAutoHeight());

	    this.$once('hook:beforeDestroy', () => {
	        this.$refs.body.removeEventListener('transitionend', () => setAutoHeight());
	    });
	}

	determineMode(): void {
	    const minHeight = this.calculateMinHeight();

	    if (!this.$refs || !this.$refs.body) {
	        return;
	    }

	    // Only show "show more" if needed. Hide gradient if not relevant.
	    this.isContentOverflowing = this.$refs.body.scrollHeight > minHeight;
	    if (this.isContentOverflowing) {
	        // the height of body is larger than "min height", so "read more" feature makes sense.
	        this.showFullContent = false;
	    }

	    if (this.showFullContent) {
	        const expandedHeight = this.$refs.body.scrollHeight;
	        this.$refs.body.style.height = expandedHeight + 'px';
	    } else if (this.isContentOverflowing) {
	        this.$refs.body.style.height = minHeight + 'px';
	    }
	}

	calculateAnimDuration() {
	    const animationTime = this.animationTime + this.calculateMinHeight(true) * this.animationTimeMod;
	    this.animationDuration = animationTime;
	}

	get getStyle() {
	    return {
	        'transition-duration': `${this.animationDuration}ms`
	    };
	}

	calculateMinHeight(forced = false): number {
	    if (this.minItems || forced) {
	        const items = this.$slots.default;
	        if (items) {
	            let totalHeight = 0;

	            for (let i = 0; i < items.length; ++i) {
	                if (!forced && i >= this.minItems) break;

	                totalHeight += (items[i].elm as HTMLElement)?.scrollHeight ?? 0;
	            }

	            return totalHeight;
	        }
	    }
	    return this.minHeight;
	}

	toggleShowFullContent(): void {
	    this.showFullContent = !this.showFullContent;

	    const expandedHeight = this.$refs.body.scrollHeight;
	    this.$refs.body.style.height = expandedHeight + 'px';

	    // Set a timeout to allow the browser to calculate the transition
	    if (!this.showFullContent) {
	        setTimeout(() => {
	            this.$refs.body.style.height = this.calculateMinHeight() + 'px';
	        }, 0);
	    }
	}
}
